<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Helen and Iago are a mother and son team. Helen loves to write and Iago likes to think up plots and ideas.</p><br/>
<p style="text-indent:0em !important">Helen was born in Liverpool in 1953 and has spent most of her life working in science and research.</p><br/>
<p style="text-indent:0em !important">Iago was born in Bern in 1982 and runs a village pub and microbrewery of which he is part owner.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?30a445b5